import { render, staticRenderFns } from "./ym-sales-volume-summary.vue?vue&type=template&id=8b5b8f26&scoped=true&"
import script from "./ym-sales-volume-summary.vue?vue&type=script&lang=js&"
export * from "./ym-sales-volume-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5b8f26",
  null
  
)

export default component.exports